<input (click)="picker.open()"
       (dateInput)="addEvent('input', $event)"
       [class]="inputClass"
       [matDatepicker]="picker"
       [max]="maxDate"
       [placeholder]="placeholder"
       [value]="dateValue"
       matInput
       readonly
       type="text">
<mat-datepicker #picker [startAt]="startAt" startView="multi-year"></mat-datepicker>
